import { Component, OnInit, AfterViewChecked } from '@angular/core';

@Component({
  selector: 'app-qrgen',
  templateUrl: './qrgen.component.html',
  styleUrls: ['./qrgen.component.css'],
})
export class QrgenComponent implements OnInit, AfterViewChecked {
  constructor() {}
  data: string = 'QRGen';
  link: any;
  colorD: any = '#000044';
  colorL: any = '#ffffff';
  ngOnInit(): void {}

  ngAfterViewChecked(): void {
    this.link = document.querySelector('img').src;
    console.clear();
  }
}
